import * as React from "react";
import { useRef, useEffect, useState } from "react";
import upperCase from "lodash/upperCase";
import EntityShareDomain from "domainActions/permissions/EntityShareDomain";
import { createGRN } from "logic/permissions/GRN";
import { useStore } from "stores/connect";
import { Spinner } from "components/common";
import { EntityShareStore } from "stores/permissions/EntityShareStore";
import BootstrapModalConfirm from "components/bootstrap/BootstrapModalConfirm";
import useSendTelemetry from "logic/telemetry/useSendTelemetry";
import { TELEMETRY_EVENT_TYPE } from "logic/telemetry/Constants";
import EntityShareSettings from "./EntityShareSettings";
const EntityShareModal = ({
  description,
  entityId,
  entityType,
  entityTitle,
  entityTypeTitle = void 0,
  onClose,
  showShareableEntityURL = true
}) => {
  var _a;
  const { state: entityShareState } = useStore(EntityShareStore);
  const [disableSubmit, setDisableSubmit] = useState((_a = entityShareState == null ? void 0 : entityShareState.validationResults) == null ? void 0 : _a.failed);
  const entityGRN = createGRN(entityType, entityId);
  const granteesSelectFormRef = useRef();
  const sendTelemetry = useSendTelemetry();
  useEffect(() => {
    EntityShareDomain.prepare(entityType, entityTitle, entityGRN);
  }, [entityType, entityTitle, entityGRN]);
  const _handleSave = () => {
    var _a2, _b, _c;
    setDisableSubmit(true);
    const selectedGranteeId = (_b = (_a2 = granteesSelectFormRef.current) == null ? void 0 : _a2.values) == null ? void 0 : _b.granteeId;
    const payload = {
      selected_grantee_capabilities: entityShareState.selectedGranteeCapabilities
    };
    if (selectedGranteeId) {
      const selectedGrantee = entityShareState == null ? void 0 : entityShareState.availableGrantees.find((grantee) => grantee.id === selectedGranteeId);
      if (
        // eslint-disable-next-line no-alert
        !window.confirm(
          `${selectedGrantee.title ? `"${selectedGrantee.title}"` : "An entity (name not found)"} got selected but was never added as a collaborator. Do you want to continue anyway?`
        )
      ) {
        setDisableSubmit(false);
        return;
      }
    }
    sendTelemetry((_c = TELEMETRY_EVENT_TYPE.ENTITYSHARE) == null ? void 0 : _c[`ENTITY_${upperCase(entityType)}_SHARED`], {
      app_pathname: entityType
    });
    EntityShareDomain.update(entityType, entityTitle, entityGRN, payload).then(() => {
      setDisableSubmit(true);
      onClose();
    });
  };
  return /* @__PURE__ */ React.createElement(
    BootstrapModalConfirm,
    {
      confirmButtonDisabled: disableSubmit,
      confirmButtonText: "Update sharing",
      onConfirm: _handleSave,
      onCancel: onClose,
      showModal: true,
      title: /* @__PURE__ */ React.createElement(React.Fragment, null, "Sharing ", entityTypeTitle != null ? entityTypeTitle : entityType, ": ", /* @__PURE__ */ React.createElement("i", null, entityTitle))
    },
    entityShareState && entityShareState.entity === entityGRN ? /* @__PURE__ */ React.createElement(
      EntityShareSettings,
      {
        description,
        entityGRN,
        entityType,
        entityTypeTitle,
        entityTitle,
        entityShareState,
        granteesSelectFormRef,
        setDisableSubmit,
        showShareableEntityURL
      }
    ) : /* @__PURE__ */ React.createElement(Spinner, null)
  );
};
export default EntityShareModal;
